<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields">
      <template #thead-top="data">
        <b-tr>
          <b-th colspan="1" style="text-align: center"></b-th>
          <b-th colspan="2" style="text-align: center">养老</b-th>
          <b-th colspan="2" style="text-align: center">医疗</b-th>
          <b-th colspan="2" style="text-align: center">失业</b-th>
          <b-th colspan="5" style="text-align: center"></b-th>
        </b-tr>
      </template>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(gjjFeeDw)="data">
        {{ Number(data.item.gjjFeeDw).toFixed(2) }}
      </template>
      <template v-slot:cell(gjjFeeGe)="data">
        {{ Number(data.item.gjjFeeGe).toFixed(2) }}
      </template>
      <template v-slot:cell(gjjPayPercent)="data">
        {{ Number(data.item.gjjPayPercent).toFixed(2) }}
      </template>
      <template v-slot:cell(gjjPayFee)="data">
        {{ Number(data.item.gjjPayFee).toFixed(2) }}
      </template>
      <template v-slot:cell(otherFee)="data">
        {{ Number(data.item.otherFee).toFixed(2) }}
      </template>


      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "HrSalaryCalcLeaveExtraDetail",
  data() {
    return {
      fields: [
        {key: 'gjjQueryMonth', label: '所属月份', width: '120px'},
        {key: 'gjjFeeDw', label: '公司', width: '120px'},
        {key: 'gjjFeeGe', label: '个人', width: '120px'},
        {key: 'gjjPayPercent', label: '支付比例', width: '120px'},
        {key: 'gjjPayFee', label: '支付金额', width: '120px'},
        {key: 'otherFee', label: '支付金额', width: '120px'},
        {key: 'otherContent', label: '支付内容', width: '120px'},
      ],
      items: [],
      columnLength: 0,
    }
  },
  created() {
    this.items = [JSON.parse(this.$route.query.data)]
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value));
        }
        return total;
      }, 0).div(this.items.length).toFixed(0, Decimal.ROUND_HALF_UP);
    }
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>
